import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PAYWALL_TIMER_MINUTES } from '@/constants';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { AI_DATA } from '@/pages/Onboarding/constants';

import { OnboardingPaywallAICard } from '../../components/AICard';
import { LimitedTimer } from '../../components/LimitedTimer';

import './Images.scss';

export const OnboardingPaywallSectionImages: React.FC = () => {
  const aiData = AI_DATA[webCampaign.aiType];

  return (
    <section className="images">
      <OnboardingTitle className="title images-title" color="black">
        Welcome to your{' '}
        <UiTypography variant="inherit" color="gradient" component="span">
          AI-Universe
        </UiTypography>
      </OnboardingTitle>
      <UiTypography
        variant="body-large"
        className="images-subtitle"
        color="black"
      >
        Your private non-judgemental space
      </UiTypography>
      <div className="images-container">
        <div className="ai-image-main-container">
          <img src={aiData.main.imageSrc} alt="AI" />
        </div>

        <div className="arrow-down">
          <img
            src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/paywall/arrow-down.png"
            alt="Arrow down"
            className="icon"
          />
        </div>

        <OnboardingPaywallAICard
          title={aiData.cards[0].title}
          subtitle={aiData.cards[0].subtitle}
          imageSrc={aiData.cards[0].imageSrc}
          className="ai-card--1 ai-card--positioned"
        />
        <OnboardingPaywallAICard
          title={aiData.cards[1].title}
          subtitle={aiData.cards[1].subtitle}
          imageSrc={aiData.cards[1].imageSrc}
          className="ai-card--2 ai-card--positioned"
        />
        <OnboardingPaywallAICard
          title={aiData.cards[2].title}
          subtitle={aiData.cards[2].subtitle}
          imageSrc={aiData.cards[2].imageSrc}
          className="ai-card--3 ai-card--positioned"
        />
        <LimitedTimer
          className="timer"
          timeToExpire={PAYWALL_TIMER_MINUTES * 1000 * 60}
        />
      </div>
    </section>
  );
};
